import React, { } from "react";
import TopMenu from "../../components/airpreset/Topmenu";
import LLM from "./components/LLM";
import Classification from "./components/Classification";
import Slot from "./components/Slot";
import Sentiment from "./components/Sentiment";
import ModelB from "./components/ModelB";

const Aipreset = () => {
  const [activeMenu, setActiveMenu] = React.useState<string>('');
  const handler = (data) => {
    setActiveMenu(data);
  }
  return (
    <>
      <TopMenu handler={handler} />
      {(() => {
        switch (activeMenu) {
          case 'LLM':
            return <LLM />;
          case 'Classification':
            return <Classification />;
          case 'Slot':
            return <Slot />;
          case 'Sentiment':
            return <Sentiment />;
          case 'Model B':
            return <ModelB />;
          default:
            return <LLM />;
        }
      })()}
    </>
  );

};

export default Aipreset;
